module.exports = __webpack_public_path__ + "static/media/menuIcon.b8718b70.svg";